// extracted by mini-css-extract-plugin
export var deliveryRow = "_ql-a";
export var fixedHeight = "_ql-4";
export var freightLogo = "_ql-9";
export var fullWidth = "_ql-3";
export var priceColumn = "_ql-5";
export var radioSelected = "_ql-7";
export var radioUnselected = "_ql-6";
export var selectedOption = "_ql-2";
export var selectedOptionContainer = "_ql-1";
export var selection = "_ql-0";
export var tallSkeletonText = "_ql-8";